import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGame } from '../../backend/useGame';
import LoadingSpinner from '../../ui/components/LoadingSpinner';
import styled from 'styled-components';
import Colors from '../../ui/global/Colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: ${Colors.black};
  color: ${Colors.white};
  gap: 20px;
`;

const RemixAction = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const { remixGame } = useGame();

  useEffect(() => {
    const performRemix = async () => {
      if (!gameId) return;
      try {
        // Trigger the existing remix logic
        const newGameId = await remixGame(gameId);
        if (newGameId) {
          // Redirect to the editor with the new ID
          navigate(`/game/${newGameId}`);
        } else {
          // Fallback if remix fails
          navigate('/game');
        }
      } catch (error) {
        console.error('Failed to remix game:', error);
        navigate('/game');
      }
    };

    performRemix();
  }, [gameId, remixGame, navigate]);

  return (
    <Container>
      <LoadingSpinner colorMode="dark" />
      <p>Remixing game...</p>
    </Container>
  );
};

export default RemixAction;